import React from "react";
import OrderTable from "../Table";

const ReadyForPickup = () => {
  return <OrderTable type="Ready for Pickup" />;
};

export default ReadyForPickup;
